(() => {
  if (customElements.get('gf-ingredient-cards')) return;
  customElements.define('gf-ingredient-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.gfi-card > summary');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        this.trigger = summary;
        const card = summary.parentElement;
        const photo = this.dialog.querySelector('.gfi-dialog-photo');
        photo.src = summary.querySelector('img').src;
        this.dialog.querySelector('h2').textContent = summary.querySelector('.gfi-name').textContent;
        this.dialog.querySelector('.gfi-dialog-content').replaceChildren(...Array.from(card.querySelector('.gfi-detail').childNodes, node => node.cloneNode(true)));
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.dialog.scrollTop = 0;
        this.dialog.querySelector('.gfi-close').focus();
      });
      this.dialog.querySelector('.gfi-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow ?? '';
        if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow ?? '';
      }
    }
  });
})();
